import "firebase/firestore";

import { tUserConnection } from "tmt_api/src/types/types.validator";

import api from "../../util/api";
import { tReduxAction } from "../types";

export const updateConnectionData = (myConnectionData: tUserConnection, myNewRepEmail: string): tReduxAction => {
  return (dispatch) => {
    api
      .put(
        {
          endpoint: "/connections/update",
          body: {
            connection: myConnectionData,
            newRepEmail: myNewRepEmail,
          },
        },
        {},
        {
          "Access-Control-Allow-Origin": "*",
        },
      )
      .then(() => dispatch({ type: "RIBBON", message: "Data successfully updated." }))
      .catch((e) => dispatch({ type: "ERROR", error: e.message }));
  };
};
